export const AGREE_PDF_CONTENTS = [
  {
    lang: 'en',
    content: {
      value: '/pdfs/agree/en/agreement.pdf',
    },
  },
  {
    lang: 'cn',
    content: {
      value: '/pdfs/agree/cn/agreement.pdf',
    },
  },
  {
    lang: 'tw',
    content: {
      value: '/pdfs/agree/tw/agreement.pdf',
    },
  },
  {
    lang: 'ko',
    content: {
      value: '/pdfs/agree/ko/agreement.pdf',
    },
  },
  {
    lang: 'ja',
    content: {
      value: '/pdfs/agree/ja/agreement.pdf',
    },
  },
  {
    lang: 'pt',
    content: {
      value: '/pdfs/agree/pt/agreement.pdf',
    },
  },
];
